// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    StretchVertical,
    Strikethrough,
    Subscript,
    Summary,
    Sun,
    SunDim,
    SunMedium,
    SunMoon,
    SunSnow,
    Sunrise,
    Sunset,
    Superscript,
    SwatchBook,
    SwissFranc,
    SwitchCamera,
    Sword,
    Swords,
    Syringe,
    Table,
    Table2,
    TableCellsMerge,
    TableCellsSplit,
    TableColumnsSplit,
    TableOfContents,
    TableProperties,
    TableRowsSplit,
    Tablet,
    TabletSmartphone,
    Tablets,
    Tag,
    TagPlus,
    TagX,
    Tags,
    Tally1,
    Tally2,
    Tally3,
    Tally4,
    Tally5,
    Tangent,
    Target,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "stretch-vertical" through "target", inclusive. */
const shard: Record<string, LucideIcon> = {
    "stretch-vertical": StretchVertical,
    strikethrough: Strikethrough,
    subscript: Subscript,
    summary: Summary,
    sun: Sun,
    "sun-dim": SunDim,
    "sun-medium": SunMedium,
    "sun-moon": SunMoon,
    "sun-snow": SunSnow,
    sunrise: Sunrise,
    sunset: Sunset,
    superscript: Superscript,
    "swatch-book": SwatchBook,
    "swiss-franc": SwissFranc,
    "switch-camera": SwitchCamera,
    sword: Sword,
    swords: Swords,
    syringe: Syringe,
    table: Table,
    "table-2": Table2,
    "table-cells-merge": TableCellsMerge,
    "table-cells-split": TableCellsSplit,
    "table-columns-split": TableColumnsSplit,
    "table-of-contents": TableOfContents,
    "table-properties": TableProperties,
    "table-rows-split": TableRowsSplit,
    tablet: Tablet,
    "tablet-smartphone": TabletSmartphone,
    tablets: Tablets,
    tag: Tag,
    "tag-plus": TagPlus,
    "tag-x": TagX,
    tags: Tags,
    "tally-1": Tally1,
    "tally-2": Tally2,
    "tally-3": Tally3,
    "tally-4": Tally4,
    "tally-5": Tally5,
    tangent: Tangent,
    target: Target,
};

export default shard;
